import styled from "styled-components";


export const ContainerPostMain = styled.div`
  @media (max-width: 600px) {
    margin-top: 40px;
  }
`;
